export default "__VITE_ASSET__BVbHA$cj__"